export default "__VITE_ASSET__CG0WW2fd__"